import React from 'react';
import './InfoBanner.css';

const InfoBanner: React.FC = () => {
  return (
    <div className="info-banner">
      <div className="scrolling-text">
        <span className="info-dot" aria-hidden="true"></span>
        Prise de rendez-vous — en cabinet, à domicile comme en téléconsultation —
        exclusivement via&nbsp;Doctolib
        <span className="info-sep" aria-hidden="true">•</span>
        Nawel Bouchoukh, Psychologue clinicienne — Maisons-Alfort
      </div>
    </div>
  );
};

export default InfoBanner;